import {
  AfterViewInit,
  Component,
  ElementRef,
  HostBinding,
  Input,
  OnInit,
  ViewChild,
} from '@angular/core';
import { Observable, Subject, takeUntil } from 'rxjs';

import { FilterInput } from '../interfaces/filter.interface';

@Component({
  selector: 'rr-text-filter-input-element',
  templateUrl: './text-input-element.component.html',
  styleUrls: ['./text-input-element.component.scss'],
})
export class TextInputElementComponent implements AfterViewInit, OnInit {
  @Input() inputData$: Observable<FilterInput>;
  @Input() reset$: Observable<string>;

  @HostBinding('hidden')
  public isHidden: boolean = true;

  public onDataChanged: (value: string) => void = (_) => {};
  public onBackClicked: () => void = () => {};

  private _onDestroy: Subject<void> = new Subject();
  private _id: string = '';

  @ViewChild('inputText') inputText: ElementRef<HTMLInputElement>;

  filterValue: string = '';

  constructor() {}

  ngOnInit(): void {
    this._onDestroy = new Subject();
  }

  ngOnDestroy(): void {
    this._onDestroy.next();
    this._onDestroy.complete();
    this._onDestroy = undefined;
  }

  ngAfterViewInit(): void {
    this.inputData$.pipe(takeUntil(this._onDestroy)).subscribe((data) => {
      this.isHidden = data.hidden;
      this.onDataChanged = data.onChange;
      this.onBackClicked = data.onBackClicked;
      this._id = data.id;
    });
    this.reset$.pipe(takeUntil(this._onDestroy)).subscribe((filterId) => {
      if (this._id === filterId || filterId === '') {
        this.filterValue = '';
      }
    });
  }

  detectChanges(event: Event | KeyboardEvent) {
    if ('key' in event && event.key === 'Escape') {
      console.log((event as KeyboardEvent).key);
      this.inputText.nativeElement.value = '';
    }
    if (
      this.inputText &&
      this.filterValue !== this.inputText.nativeElement.value
    ) {
      this.filterValue = this.inputText?.nativeElement.value;

      this.onDataChanged(this.filterValue);
    }
  }
}
